module.exports = __webpack_public_path__ + "img/history-hero.jpg?cb8ae989f590591283d3ea93eb0cd1b9";